import { render, staticRenderFns } from "./modalPagoRealizado.vue?vue&type=template&id=3d6e07b4"
import script from "./modalPagoRealizado.vue?vue&type=script&lang=js"
export * from "./modalPagoRealizado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports